import { useSelector } from 'react-redux';
import { Box, Button, Icon, Text } from '@quintoandar-tokko/jopijs';
import styles from './editionSectionTitle.module.scss';
import DashboardSectionTitle from '../DashboardSectionTitle';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import ToolTip from '@/components/ToolTip/ToolTip';

export default function EditionSectionTitle({
  tabId,
  sectionId,
  children,
  visible = false,
  moveNext,
  movePrev,
  prevDisabled,
  nextDisabled,
  toggleHide,
  withTitle = true,
  ...rest
}) {
  const { edition } = useSelector((state) => state.DashboardSlice);

  const classNames = `${styles.editionSectionTitle} ${
    edition.active ? styles.editionSectionTitleActive : ''
  } ${!visible ? styles.editionSectionTitleHide : ''}`;

  if (!withTitle) return null;
  if (!edition.active && !children) return null;

  const safetyIsPrevDisabled = prevDisabled || !visible;
  const safetyIsNextDisabled = nextDisabled || !visible;

  return (
    <Box className={classNames}>
      <Box className={styles.childrenWrapper}>
        <DashboardSectionTitle {...rest}>{children}</DashboardSectionTitle>
      </Box>

      <Box className={styles.controlsWrapper}>
        <Box className={styles.iconsContainer}>
          <ToolTip
            title={
              !safetyIsPrevDisabled &&
              Trans(translations, 'TheEntireSectionWillMove')
            }
          >
            <Button
              variant={[
                safetyIsPrevDisabled
                  ? 'secondaryDisabled'
                  : 'secondaryOutlined',
              ]}
              className={styles.iconBtnWrapper}
              onClick={movePrev}
              data-disabled={safetyIsPrevDisabled}
            >
              <Icon icon="icon-flechaarriba" className={styles.icon} />
            </Button>
          </ToolTip>
          <ToolTip
            title={
              !safetyIsNextDisabled &&
              Trans(translations, 'TheEntireSectionWillMove')
            }
          >
            <Button
              variant={[
                safetyIsNextDisabled
                  ? 'secondaryDisabled'
                  : 'secondaryOutlined',
              ]}
              className={styles.iconBtnWrapper}
              onClick={moveNext}
              data-disabled={safetyIsNextDisabled}
            >
              <Icon icon="icon-flechaabajo" className={styles.icon} />
            </Button>
          </ToolTip>
        </Box>

        <ToolTip
          title={Trans(
            translations,
            visible
              ? 'TheEntireSectionWillBeHidden'
              : 'TheEntireSectionWillBeDisplayed'
          )}
        >
          <Button
            variant={['secondaryOutlined', 'small']}
            className={styles.btn}
            onClick={toggleHide}
          >
            <Icon
              icon={visible ? 'icon-ocultar' : 'icon-ver'}
              className={styles.icon}
            />
            <Text className={styles.btnText}>
              {Trans(translations, visible ? 'HideSection' : 'ShowSection')}
            </Text>
          </Button>
        </ToolTip>
      </Box>
    </Box>
  );
}
